import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { safeJsonLd } from "@/lib/structured-data";
import { getWestStructuredData } from "@/lib/structured-data/west";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { ValueProps } from "@/components/site/ValueProps";
import { Footer } from "@/components/site/Footer";
import { useLocalQuoteLinks } from "@/hooks/use-local-quote-links";


const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const Pricing = lazy(() => import("@/components/site/Pricing").then(m => ({ default: m.Pricing })));
const DoctorBio = lazy(() => import("@/components/site/DoctorBio").then(m => ({ default: m.DoctorBio })));
const Surgeons = lazy(() => import("@/components/site/Surgeons").then(m => ({ default: m.Surgeons })));
const DoctorsGrid = lazy(() => import("@/components/site/DoctorsGrid").then(m => ({ default: m.DoctorsGrid })));
const WestLocations = lazy(() => import("@/components/site/WestLocations").then(m => ({ default: m.WestLocations })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/locations/restore-west")({
  head: () => ({
    meta: [
      { title: "Get Your Hair Back in the West | RESTORE® Hair Transplants" },
      {
        name: "description",
        content:
          "RESTORE® Hair serves the Western US: Arizona, California, Colorado, Idaho, Montana, Nevada, New Mexico, Oregon, Utah, Washington and Wyoming.",
      },
      { property: "og:title", content: "Get Your Hair Back in the West | RESTORE® Hair Transplants" },
      {
        property: "og:description",
        content:
          "Top hair restoration team serving the Western United States. Soft, natural, undetectable results.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/restore-west/" },
    ],
    // A paid landing page with the home page's content (6-gram overlap 0.84 to
    // 1.0 on 16 Oct 2026) and no organic clicks in 90 days. The canonical
    // points at the home page so search signals consolidate there. Ads are
    // not affected: Google Ads does not read the canonical.
    links: [{ rel: "canonical", href: "https://restorehair.com/" }],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({ "@graph": getWestStructuredData() }),
      },
    ],
  }),
  component: RestoreWest,
});

function RestoreWest() {
  useLocalQuoteLinks({ allToNorwoodPage: true });
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <Hero />
        <NorwoodQuiz />
        <ValueProps hideEyebrowMobile />
        <Suspense fallback={null}>
          <Results hideEyebrowMobile />
          <Reviews hideEyebrowMobile />
          <NoShaveFuture />
          <NoShaveWhy />
          <Guarantee />
          <Pricing />
          <DoctorBio />
          <Surgeons />
          <DoctorsGrid />
          <WestLocations />
          <VirtualConsult />
          <Faq />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
